import write from "./Creative Writing.png";
import debate from "./Debate.png"
import jam from "./English JAM.png";
import hind from "./Abhivyakti.png";



const Data = [
    {
        event_no : '#001',
        event_name : "DEBATE",
        event_desc : "Nothing brings more joy and thrill to a ferocious mind than an argument that allows one to bring out their hard-earned knowledge and conquer the hearts of their listeners. In the wake of this realization, Odyssey literary society has constructed an arena for the eristic beings, a beacon that serves to bring together the warriors of literature and separate the best from the rest. A perfect platform to begin your journey and become an invincible speaker.",
        Logo : debate
    },
    {
        event_no : '#002',
        event_name : "JUST-A-MINUTE",
        event_desc : "In this exceptionally swift reality, it takes but a mere moment to seize the spotlight and have the world listen to your majestic words. We, offer you a minute. Odyssey literary society brings to the scholars of English an opportunity to showcase their vast vocabulary and cast their nimble thinking on the oscillations of their vibrations. An experience infused with a rush of goosebumps and nerve-wracking competition. A minute, to achieve distinction.",
        Logo : jam
    },
    {
        event_no : '#003',
        event_name : "CREATIVE-WRITING",
    event_desc : "A pen is never mightier than a sword, the mighty is the mind of the scholar that wields it. The masters who hone their craft, in an endless pursuit of perfection in their flair, carry the minds that can shape their unbound imagination, and weave them into the most alluring display of their craft. This event is the platform where the wizards of literature will spellbind the readers with an intimate portrayal of charm and zeal, reflected by their words. So register now, and join this bout of magicians.",
        Logo : write
    },
    {
        event_no : '#004',
        event_name : "HINDI-JAM",
        event_desc : "हे महारथी, अपने वक्तव्य की कुशलता से सभी को मंत्रमुग्ध करने की क्षमता रखने वाले, अपनी सुरीली, सुमधुर व तीव्र वाणी से हमें ओत-प्रोत करने वाले, स्वर्णिम वाक्यांशो के अनुपम रचयता, आप हमें कहा मिलेंगे ? कृपया हमें अपने और अपनी कला के दर्शन का सौभाग्य प्रदान करें। हमें आशा है कि आपकी मीठी आवाज़ जब हमारे कर्णों में समाएगी तब हमारे मन-मस्तिष्क को जो परमानंद प्राप्त होगा वह निश्चित ही अतुलनीय होगा। हे आलौकिक स्वर वंदन धारी, हम आपकी तलाश बेसब्री से कर रहें हैं। कहां हैं आप? वह आप भी हो सकते हैं? जी हां!!",
        Logo : hind
    },

]

export default Data;